var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/landing-page/index.tsx";
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { prepareRequest } from 'soapbox/actions/consumer-auth';
import Markup from 'soapbox/components/markup';
import { Button, Card, CardBody, Stack, Text } from 'soapbox/components/ui';
import VerificationBadge from 'soapbox/components/verification-badge';
import RegistrationForm from 'soapbox/features/auth-login/components/registration-form';
import { useAppDispatch, useAppSelector, useFeatures, useSoapboxConfig } from 'soapbox/hooks';
import { capitalize } from 'soapbox/utils/strings';

const LandingPage = () => {
  const dispatch = useAppDispatch();
  const features = useFeatures();
  const soapboxConfig = useSoapboxConfig();
  const pepeEnabled = soapboxConfig.getIn(['extensions', 'pepe', 'enabled']) === true;
  const instance = useAppSelector(state => state.instance);
  const pepeOpen = useAppSelector(state => state.verification.instance.get('registrations') === true);
  /** Registrations are closed */

  const renderClosed = () => {
    return /*#__PURE__*/React.createElement(Stack, {
      space: 3,
      "data-testid": "registrations-closed",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 24,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(Text, {
      size: "xl",
      weight: "bold",
      align: "center",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 25,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "registration.closed_title",
      defaultMessage: "Registrations Closed",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 26,
        columnNumber: 11
      }
    })), /*#__PURE__*/React.createElement(Text, {
      theme: "muted",
      align: "center",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 31,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "registration.closed_message",
      defaultMessage: "{instance} is not accepting new members.",
      values: {
        instance: instance.title
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 32,
        columnNumber: 11
      }
    })));
  };
  /** Mastodon API registrations are open */


  const renderOpen = () => {
    return /*#__PURE__*/React.createElement(RegistrationForm, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 44,
        columnNumber: 12
      }
    });
  };
  /** Display login button for external provider. */


  const renderProvider = () => {
    const {
      authProvider
    } = soapboxConfig;
    return /*#__PURE__*/React.createElement(Stack, {
      space: 3,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 52,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(Stack, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 53,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement(Text, {
      size: "2xl",
      weight: "bold",
      align: "center",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 54,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "registrations.get_started",
      defaultMessage: "Let's get started!",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 55,
        columnNumber: 13
      }
    }))), /*#__PURE__*/React.createElement(Button, {
      onClick: () => dispatch(prepareRequest(authProvider)),
      theme: "primary",
      block: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 59,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "oauth_consumer.tooltip",
      defaultMessage: "Sign in with {provider}",
      values: {
        provider: capitalize(authProvider)
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 60,
        columnNumber: 11
      }
    })));
  };
  /** Pepe API registrations are open */


  const renderPepe = () => {
    return /*#__PURE__*/React.createElement(Stack, {
      space: 3,
      "data-testid": "registrations-pepe",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 73,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(VerificationBadge, {
      className: "h-16 w-16 mx-auto",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 74,
        columnNumber: 9
      }
    }), /*#__PURE__*/React.createElement(Stack, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 76,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement(Text, {
      size: "2xl",
      weight: "bold",
      align: "center",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 77,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "registrations.get_started",
      defaultMessage: "Let's get started!",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 78,
        columnNumber: 13
      }
    })), /*#__PURE__*/React.createElement(Text, {
      theme: "muted",
      align: "center",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 80,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "registrations.tagline",
      defaultMessage: "Social Media Without Discrimination",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 81,
        columnNumber: 13
      }
    }))), /*#__PURE__*/React.createElement(Button, {
      to: "/verify",
      theme: "primary",
      block: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 85,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "registrations.create_account",
      defaultMessage: "Create an account",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 86,
        columnNumber: 11
      }
    })));
  }; // Render registration flow depending on features


  const renderBody = () => {
    if (soapboxConfig.authProvider) {
      return renderProvider();
    } else if (pepeEnabled && pepeOpen) {
      return renderPepe();
    } else if (features.accountCreation && instance.registrations) {
      return renderOpen();
    } else {
      return renderClosed();
    }
  };

  return /*#__PURE__*/React.createElement("main", {
    className: "mt-16 sm:mt-24",
    "data-testid": "homepage",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 106,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "mx-auto max-w-7xl",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 107,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 lg:grid-cols-12 gap-8 py-12",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 108,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "px-4 sm:px-6 sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left lg:flex",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 109,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 110,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    space: 3,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 111,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement("h1", {
    className: "text-5xl font-extrabold text-transparent text-ellipsis overflow-hidden bg-clip-text bg-gradient-to-br from-accent-500 via-primary-500 to-gradient-end sm:mt-5 sm:leading-none lg:mt-6 lg:text-6xl xl:text-7xl",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 112,
      columnNumber: 17
    }
  }, instance.title), /*#__PURE__*/React.createElement(Markup, {
    size: "lg",
    dangerouslySetInnerHTML: {
      __html: instance.short_description || instance.description
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 116,
      columnNumber: 17
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: "sm:mt-24 lg:mt-0 lg:col-span-6 self-center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 123,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Card, {
    size: "xl",
    variant: "rounded",
    className: "sm:max-w-md sm:w-full sm:mx-auto",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 124,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(CardBody, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 125,
      columnNumber: 15
    }
  }, renderBody()))))));
};

export default LandingPage;